import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $createRangeSelection,
  $getSelection,
  $isRangeSelection,
  $setSelection,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
} from 'lexical';
import { $createSectionAnchorNode } from '../../nodes/SectionAnchorNode';

export const INSERT_SECTION_ANCHOR_COMMAND = createCommand('INSERT_SECTION_ANCHOR_COMMAND');

export default function SectionAnchorPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_SECTION_ANCHOR_COMMAND,
      (payload) => {
        const { sectionId, savedSel } = payload;
        if (!sectionId || !savedSel) return false;

        editor.update(() => {
          // Restore the selection that was snapshotted before the modal opened
          const restored = $createRangeSelection();
          restored.anchor.key = savedSel.anchorKey;
          restored.anchor.offset = savedSel.anchorOffset;
          restored.anchor.type = savedSel.anchorType;
          restored.focus.key = savedSel.focusKey;
          restored.focus.offset = savedSel.focusOffset;
          restored.focus.type = savedSel.focusType;
          $setSelection(restored);

          const selection = $getSelection();
          if (!$isRangeSelection(selection) || selection.isCollapsed()) return;

          // extract() splits TextNodes at the selection boundaries.
          // NOTE: extract() does NOT remove nodes from the tree, it only splits
          const nodes = selection.extract();
          if (nodes.length === 0) return;

          const wrapperNode = $createSectionAnchorNode(sectionId);

          // Insert wrapper at the position of the first selected node…
          nodes[0].insertBefore(wrapperNode);

          for (const node of nodes) {
            wrapperNode.append(node);
          }
        });
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
